import { useEffect, useRef } from "react";

/**
 * Returns the previous value from the last render.
 */
export function usePrevious<T>(value: T) {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
